import { render } from "./UserEditPersonalInformation.vue?vue&type=template&id=22b1a331"
import script from "./UserEditPersonalInformation.vue?vue&type=script&lang=js"
export * from "./UserEditPersonalInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__